module.exports = __webpack_public_path__ + "media/customizations/anthemmr/logo-4f0a646fa211c0681556ce0652a51dae.png";